module.exports = __webpack_public_path__ + "static/image_18_thumb-d67e3eaef96248bb25e72ec94ff17e85.jpg";